<template>
  <div class="withdraw-method-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="130px"
        :label-position="labelPosition"
      >
        <el-form-item v-if="title === '新增提现方式'" label="提现平台:" prop="cid">
          <el-input v-model="params.channelName" size="small"></el-input>
        </el-form-item>
        <el-form-item v-if="title === '新增提现方式'" label="平台ID:" prop="cid">
          <el-input v-model="params.cid" size="small"></el-input>
        </el-form-item>
        <el-form-item label="提现方式选择:" :show-overflow-tooltip="true" prop="payType">
          <el-radio-group v-model="params.payType">
            <el-radio
              v-for="item in payMethods"
              :label="item.value"
              :key="item.label"
            >{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="平台提现权重:" prop="weight">
          <el-input v-model.number="params.weight" size="small"></el-input>
        </el-form-item>
        <el-form-item label="最小支持金额:" prop="minMoney">
          <el-input v-model.number="params.minMoney" size="small"></el-input>
        </el-form-item>
        <el-form-item label="最大支持金额:" prop="maxMoney">
          <el-input v-model.number="params.maxMoney" size="small"></el-input>
        </el-form-item>
        <el-form-item label="棋牌最小支持金额:" prop="qpMinMoney">
          <el-input v-model.number="params.qpMinMoney" size="small"></el-input>
        </el-form-item>
        <el-form-item label="激活状态:" prop="maxMoney">
          <el-switch v-model="params.active"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      params: {
        channelName: "",
        cid: "",
        payType: "",
        minMoney: 0,
        qpMinMoney: 0,
        maxMoney: 0,
        weight: "",
        active: false
      },
      payMethods: [
        { label: "支付宝", value: "alipay" },
        { label: "银行卡", value: "bankcard" }
      ],
      rules: {
        channelName: [
          { required: true, message: "请输入提现平台", trigger: "blur" }
        ],
        cid: [{ required: true, message: "请输入平台ID", trigger: "blur" }],
        payType: [
          { required: true, message: "请选择提现方式", trigger: "blur" }
        ],
        weight: [
          { required: true, message: "请输入权重", trigger: "blur" },
          { type: "number", message: "权重必须为数字" }
        ],
        minMoney: [
          { required: true, message: "请输入最小提现金额", trigger: "blur" },
          { type: "number", message: "提现金额必须为数字" }
        ],
        qpMinMoney: [
          { required: true, message: "请输入棋牌最小提现金额", trigger: "blur" },
          { type: "number", message: "提现金额必须为数字" }
        ],
        maxMoney: [
          { required: true, message: "请输入最大提现金额", trigger: "blur" },
          { type: "number", message: "提现金额必须为数字" }
        ]
      }
    };
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增提现方式") {
            this.addChannel();
          } else {
            this.editChannel();
          }
        } else {
          return false;
        }
      });
    },
    // 修改提现方式配置
    editChannel() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        minMoney: this.params.minMoney * 100,
        qpMinMoney: this.params.qpMinMoney * 100,
        maxMoney: this.params.maxMoney * 100
      });
      API.updateWChannel(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "修改提现方式成功",
              type: "success"
            });
            this.$emit("handlerChannelList");
          } else {
            this.$message.error("修改提现方式失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 添加提现方式
    addChannel() {
      let params = Object.assign({}, this.params, {
        minMoney: this.params.minMoney * 100,
        qpMinMoney: this.params.qpMinMoney * 100,
        maxMoney: this.params.maxMoney * 100
      });
      API.addWChannel(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "新增提现方式成功",
              type: "success"
            });
            this.$emit("handlerChannelList");
          } else {
            this.$message.error("新增提现方式失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        channelName: "",
        cid: "",
        payType: "",
        minMoney: 0,
        qpMinMoney: 0,
        maxMoney: 0,
        weight: "",
        active: false
      };
      this.$refs["form"].resetFields();
    }, // 打开编辑视频弹窗、传递需要编辑的参k
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑提现方式";
        this.params.channelName = data.channelName;
        this.params.cid = data.cid;
        this.params.active = data.active;
        this.params.payType = data.payType;
        this.params.minMoney = data.minMoney / 100;
        this.params.qpMinMoney = data.qpMinMoney / 100;
        this.params.maxMoney = data.maxMoney / 100;
        this.params.weight = data.weight;
        this.id = data.id;
      } else {
        this.title = "新增提现方式";
      }
    }
  }
};
</script>

<style lang="scss" >
.withdraw-method-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
